import { ISourceDataConfigurationFormFieldValue } from "@/api/dtos";
import { ISelectionOption, IUpdateMapping, updateBySelection } from ".";

export const ConfigurationUpdateValueMapping: IUpdateMapping = {
    createOptions:  (source, target) => {
        let options: ISelectionOption[] = [
            {
                name: 'options',
                label: 'Options',
                options: [
                    {
                        name: 'overrideName',
                        label: 'Override Name',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationFormFieldValue).name = (sourceValue as ISourceDataConfigurationFormFieldValue).name;
                        }
                    },
                    {
                        name: 'priority',
                        label: 'Priority',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationFormFieldValue).priority = (sourceValue as ISourceDataConfigurationFormFieldValue).priority;
                        }
                    },
                    {
                        name: 'alerts',
                        label: 'Alerts',
                        options: [
                            {
                                name: 'information',
                                label: 'Information',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormFieldValue).alertInformation = (sourceValue as ISourceDataConfigurationFormFieldValue).alertInformation;
                                }
                            },
                            {
                                name: 'warning',
                                label: 'Warning',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormFieldValue).alertWarning = (sourceValue as ISourceDataConfigurationFormFieldValue).alertWarning;
                                }
                            },
                            {
                                name: 'error',
                                label: 'Error',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormFieldValue).alertError = (sourceValue as ISourceDataConfigurationFormFieldValue).alertError;
                                }
                            },
                            {
                                name: 'success',
                                label: 'Success',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormFieldValue).alertSuccess = (sourceValue as ISourceDataConfigurationFormFieldValue).alertSuccess;
                                }
                            }
                        ]
                    }
                ]
            }
        ];

        return options;
    },
    update: (source, target, sourceValue, targetValue, options, selection) => {
        const newValue = { 
            ...targetValue,
            linked: sourceValue.linked
        };

        updateBySelection(source, target, sourceValue, targetValue, newValue, options, selection);

        return newValue;
    }
}